import { Injectable, ComponentRef } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { CclRouteTab } from "certain-common-library";
import { css_beautify } from "js-beautify";
import { HttpHeaders } from "@angular/common/http";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { processString } from "uglifycss";
import * as $ from 'jquery';
@Injectable()
export class SharedService {
    generalListLoading: boolean = false;
    unsavedData: boolean = false;
    originalData: boolean = false;
    changedData: boolean = false;
    errorStr: string;
    redirectTo: String;
    loginPopup: String;
    headers = new HttpHeaders().set("Content-Type", "application/json").set("Access-Control-Allow-Origin", "*");
    objectKeys = Object.keys;
    clearAllFilterEnabled: boolean = false;
    speakerFilterApplied: boolean = false;
    showLoader: boolean = true;
    loadingList: boolean = false;
    isUpload: boolean = false;
    setup: any;
    accountUUID: string;
    eventUUID: string;
    catalogUUID: string;
    catalogType: string = "SPEAKER";
    account: any = {};
    event: any = {};
    selectedTheme: any = {};
    sessionCustomFields: any = [];
    sessionFileCustomFields: any = [];
    sessionEnumCustomFields: any = [];
    userInfo: any;

    speakerCustomFields: any = [];
    speakerFileCustomFields: any = [];
    speakerEnumCustomFields: any = [];

    generalPreviewRef: ComponentRef<any>;
    generalPreviewRefRender: boolean = false;
    cartViewRender: boolean = false;
    ssoList: any = { data: [] };

    showMyScheduleCalendar = false;
    extendedValidElements: string =
        "p[style|title|data|id|class|hspace|vspace|width|height|align|onclick|onkeypress],button[style|title|data|id|class|hspace|vspace|width|height|align|onclick|onkeypress],span[style|title|data|id|class|hspace|vspace|width|height|align|onclick|onkeypress],div[style|title|data|id|class|hspace|vspace|width|height|align|onclick|onkeypress],a[style|title|data|id|class|hspace|vspace|width|height|align|onclick|onkeypress|href],input[style|title|data|id|class|hspace|vspace|width|height|align|onclick|onkeypress],img[style|data|id|class|src|alt|title|hspace|vspace|width|height|align|name|onclick|onkeypress]";

    sessionDays: any = [];
    sessionTimes: any = [];
    selectedFilterData: any = {};
    filterData: any = {};
    loggedInAttendee = null;
    cartData: any = {};
    favData: any = {};
    excData: any = { size: 0 };
    totalCountOfGeneralSessions = 0;
    allSessionsHidden: boolean = false;
    configs: any = {};
    currencySymbol= '$';

    publishInProgress:boolean = false;

    configTypes: any = {
        TAB_CONFIG: "TAB_CONFIG",
        HEADER_FOOTER: {
            header: "HEADER_CONFIG",
            footer: "FOOTER_CONFIG"
        },
        SPEAKER: {
            highlighted: "HIGHLIGHTED_SPEAKER_CONFIG",
            general: "GENERAL_SPEAKER_CONFIG"
        },
        DATA: {
            highlighted: "HIGHLIGHTED_DATA_SPEAKER_CONFIG",
            general: "GENERAL_DATA_SPEAKER_CONFIG"
        },
        HTML: {
            top: "HTML_TOP",
            bottom: "HTML_BOTTOM"
        },
        SPEAKER_SESSION_CONFIG: "SPEAKER_SESSION_CONFIG",
        ADDITIONAL_SETTING_CONFIG: "ADDITIONAL_SETTING_CONFIG"
    };
    sessionUrl = "";
    catalogLayoutConfig: any = {
        filterPlacement: "left",
        listType: "general",
        htmlElement: true
    };
    tabConfig: any = {
        isTabsEnabled: true,
        dateFormat: "EEEE, MMMM dd",
        tabData: "sessionDays",
        activeBorderColor: "",
        inactiveBorderColor: "",
        activeLabelColor: "",
        inactiveLabelColor: "",
        tabStyle: "underline",
        borderStyle: "solid",
        customCss: ".tabLabelSelected {font-family: ProximaNova-Bold; font-size: 24px;color: #000000;text-align: left;}"
    };
    filterSetup: any = {
        isFilterEnabled: true,
        styling: '.filterLabel {"background" : "#ddd"; "color" : "#000";}',
        standardFields: ["track", "sessionType", "sessionDate"],
        customFields: [],
        selectedFields: [
            { field: "track", type: "standardFields" },
            { field: "sessionType", type: "standardFields" },
            { field: "sessionDate", type: "standardFields" }
        ],
        expansionStyles: 1,
        selectionMechanism: 1,
        label: "Filter",
        header: {
            backgroundColor: "",
            fontStyle: "",
            fontSize: "",
            fontColor: ""
        },
        body: {
            backgroundColor: "",
            fontStyle: "",
            fontSize: "",
            fontColor: ""
        }
    };
    tabsConfig: any = {};
    expansionStyle: string;
    customTheme: any;
    speakerLayoutConfig: any = {};
    sessionLayoutConfig: any = {};
    dataConfig: any = {
        highlighted: {
            displayAs: "all_session",
            selectedList: []
        },
        promoted: {
            displayAs: "all_session",
            selectedList: []
        },
        general: {
            topLevel: {
                sortingBy: "",
                active: true,
                textConfig: {
                    backgroundColor: "",
                    fontStyle: "",
                    fontSize: "",
                    fontColor: ""
                }
            },
            secondLevel: {
                sortingBy: "",
                active: false,
                textConfig: {
                    backgroundColor: "",
                    fontStyle: "",
                    fontSize: "",
                    fontColor: ""
                }
            },
            thirdLevel: {
                sortingBy: "",
                active: false,
                textConfig: {
                    backgroundColor: "",
                    fontStyle: "",
                    fontSize: "",
                    fontColor: ""
                }
            },
            dateTimeFormats: {
                dateFormat: "EEEE, MMMM dd",
                timeFormat: "hh:mm a"
            }
        }
    };
    loginConfig: any = {
        header: {
            label: "Login",
            label_color: "#FBFBFB",
            background: "#0d2958"
        },
        body: {
            background: "#FBFBFB",
            help_text: "Log-in with the credentials you used to Register.",
            username: "Username",
            password: "Password",
            isSSOEnabled: false,
            ssoConfigs: []
        },
        footer: {
            background: "#FBFBFB",
            help_text: "If you haven’t registered, you can do so here.",
            button: {
                primary: {
                    label: "Log-in",
                    background: "#0d2958",
                    color: "#FBFBFB"
                },
                secondary: {
                    label: "Sign-up",
                    background: "#FBFBFB",
                    color: "#0d2958"
                }
            }
        }
    };
    currentLayoutSection: String;
    private _currentDrawer: {
        title: string;
        navLinks: Array<CclRouteTab>;
        saveMessage: string;
        saveLabel?: string;
        cancelLabel?: string;
        doneLabel?: string;
    } = <any>{};
    private _currentPopup: {
        title: string;
        navLinks: Array<CclRouteTab>;
        saveMessage: string;
        showFooter: boolean;
    } = <any>{};
    speakerTypes: any;
    attendeeTypes: any;
    dateFormats: any = [
        {
            label: "Friday, March 14",
            format: "EEEE, MMMM dd",
            javaFormat: "EEEE, MMMM dd"
        },
        {
            label: "Friday, 3/14",
            format: "EEEE, M/dd",
            javaFormat: "EEEE, M/dd"
        },
        {
            label: "Friday, March 14 2019",
            format: "EEEE, MMMM dd yyyy",
            javaFormat: "EEEE, MMMM dd yyyy"
        },
        {
            label: "Fri, Mar 14 2019",
            format: "EEE, MMM dd yyyy",
            javaFormat: "E, MMM dd yyyy"
        }
    ];

    timeFormats: any = [
        {
            label: "04:30 PM",
            format: "hh:mm a",
            javaFormat: "hh:mm a"
        },
        {
            label: "4:30 PM",
            format: "h:mm a",
            javaFormat: "h:mm a"
        },
        {
            label: "16:30",
            format: "HH:mm",
            javaFormat: "HH:mm"
        },
        {
            label: "4:30/16:30",
            format: "H:mm",
            javaFormat: "H:mm"
        }
    ];
    fontStyles: any = [
        {
            id: "normal",
            label: "Normal"
        },
        {
            id: "bold",
            label: "Bold"
        },
        {
            id: "italic",
            label: "Italic"
        },
        {
            id: "underline",
            label: "Underline"
        }
    ];
    fontSizes: any = this.getRanngeArray(12, 40, 2);
    fontSizesSmall: any = this.getRanngeArray(12, 22, 2);

    renderViewSubject: Subject<boolean> = new Subject<boolean>();

    constructor(private router: Router) {
        this.currentLayoutSection = "header";
    }
    renderView() {
        this.renderViewSubject.next(this.generalPreviewRefRender);
        this.loadingList = false;
    }

    renderCartViewSubject: Subject<boolean> = new Subject<boolean>();
    renderCartView() {
        this.renderCartViewSubject.next(this.cartViewRender);
    }

    public get currentDrawer(): {
        title: string;
        navLinks: Array<CclRouteTab>;
        saveMessage: string;
        saveLabel?: string;
        cancelLabel?: string;
        doneLabel?: string;
    } {
        return this._currentDrawer;
    }
    public set currentDrawer(value: {
        title: string;
        navLinks: Array<CclRouteTab>;
        saveMessage: string;
        saveLabel?: string;
        cancelLabel?: string;
        doneLabel?: string;
    }) {
        value.saveLabel = value.saveLabel != null ? value.saveLabel : "Apply";
        value.cancelLabel = value.cancelLabel != null ? value.cancelLabel : "Close";
        value.doneLabel = value.doneLabel != null ? value.doneLabel : "Done";
        this._currentDrawer = value;
    }

    public get currentPopup(): {
        title: string;
        navLinks: Array<CclRouteTab>;
        saveMessage: string;
        showFooter: boolean;
    } {
        return this._currentPopup;
    }
    public set currentPopup(value: {
        title: string;
        navLinks: Array<CclRouteTab>;
        saveMessage: string;
        showFooter: boolean;
    }) {
        this._currentPopup = value;
    }
    public beautifyCSS(css) {
        if (css != null) {
            return css_beautify(css, {
                indent_size: 5
            });
        } else {
            return "";
        }
    }
    public getParameterByName(name: string) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
        var results = regex.exec(location.search);
        return results == null || results.length <= 0 ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    public unsubscribeHelper(subscription: Subscription) {
        if (subscription != null) {
            subscription.unsubscribe();
        }
    }

    public catalogNavigateHelper(urlPrefix: string, urlPortion: string) {
        if (!urlPrefix.endsWith("/")) {
            urlPrefix = urlPrefix + "/";
        }
        if (!urlPortion.startsWith("/")) {
            urlPortion = "/" + urlPortion;
        }
        this.navigateHelper(urlPrefix + this.catalogUUID + urlPortion);
    }

    public navigateHelper(url: string) {
        this.router.navigate([url]);
    }

    public navigateToOutlet(outlet: string, url: string) {
        if (outlet == "drawer") {
            this.router.navigate([{ outlets: { drawer: url } }]);
        } else if (outlet == "popup") {
            this.router.navigate([{ outlets: { popup: url } }]);
        }
    }

    public getDateFormatArray(date) {
        var dt = new Date(date);
        return dt;
    }

    public getDateArray(start, end) {
        var arr = new Array();
        if (start != null && end != null) {
            var dt = new Date(start);
            while (dt <= end) {
                arr.push(new Date(dt));
                dt.setDate(dt.getDate() + 1);
            }
        }
        return arr;
    }

    public getRanngeArray(start, end, offset) {
        var arr = new Array();
        if (start != null && end != null) {
            while (start <= end) {
                arr.push(start);
                start = start + (offset ? offset : 1);
            }
        }
        return arr;
    }
    public toCamelCase(str) {
        return str.replace(/^(.)/g, function($1) {
            return $1.toUpperCase();
        });
    }

    public isEmptyString(str) {
        return str == null || str == "undefined" || str == "null" || str.trim().length == 0;
    }

    public encodeId = function(id) {
        var slope = 19;
        var intercept = 267;
        return id * slope + intercept;
    };

    public isMSIE() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
        {   
            return true;
        }
        else  // If another browser, return false
        {
            return false;
        }
    }

    public updateCss() {
        var cssPath =
            `/accounts/${this.event.fileDir}speaker_catalog_${this.catalogUUID}.css` +
            "?random=" +
            new Date().getTime();
        $("#stylesheet").empty();
        $("#stylesheet").prepend(`<link rel="stylesheet" type="text/css" href="${cssPath}" />`);
    }

    public createCss(catalogService) {
        let cssString = "";
        cssString = cssString.concat(this.createCssTabs(this.configs[`${this.configTypes.TAB_CONFIG}`]));
        cssString = cssString.concat(this.createCssSpeaker(this.configs[`${this.configTypes.SPEAKER.highlighted}`]));
        cssString = cssString.concat(this.createCssSpeaker(this.configs[`${this.configTypes.SPEAKER.general}`]));
        cssString = cssString.concat(
            this.createCssSpeakerSession(this.configs[`${this.configTypes.SPEAKER_SESSION_CONFIG}`])
        );
        cssString = cssString.concat(this.createCssGeneralData(this.configs[`${this.configTypes.DATA.general}`]));
        // cssString = processString(cssString); // minifies the css string.commented here becoz not working in IE
        const cssBlob = new Blob([cssString], { type: "text/plain" });
        const formData: FormData = new FormData();
        formData.append("file", cssBlob, `speaker_catalog_${this.catalogUUID}.css`);
        catalogService.saveCss(formData).subscribe(() => {
            this.updateCss();
        });
    }

    private createCssTabs({ config }) {
        config = JSON.parse(config);
        let cssString = "";
        cssString = cssString.concat(
            ".tab-element-custom { ",
            `color: ${config.inactiveLabelColor}; `,
            `border-bottom-color: ${config.inactiveBorderColor}; `,
            `border-bottom-style: ${config.borderStyle}; `,
            "} "
        );
        cssString = cssString.concat(
            ".tab-element-custom.active { ",
            `color: ${config.activeLabelColor}; `,
            `border-bottom-color: ${config.activeBorderColor}; `,
            "} "
        );
        cssString = cssString.concat(
            ".tab-element-custom-tab { ",
            `box-shadow: 0 0 3px ${config.inactiveBorderColor}; `,
            "margin: 5px; ",
            `background: ${config.inactiveBorderColor}; `,
            "border-bottom: 0px; } ",
            ".tab-element-custom-tab.active { ",
            `box-shadow: 0 0 3px ${config.activeBorderColor}; `,
            `background: ${config.activeBorderColor}; `,
            "} "
        );
        cssString = cssString.concat(
            ".tab-element-custom-underline { ",
            "box-shadow: none; ",
            "margin: 5px; ",
            "background: none; ",
            "border-bottom: ''; }",
            ".tab-element-custom-underline.active { ",
            "background: none; " + "} "
        );

        return cssString;
    }

    private createCssSpeaker({ config, configType }) {
        config = JSON.parse(config);
        let classPrefix: string;
        let cssString = "";

        classPrefix =
            configType === this.configTypes.SPEAKER.general
                ? this.configTypes.SPEAKER.general
                : this.configTypes.SPEAKER.highlighted;

        classPrefix = classPrefix
            .toLowerCase()
            .replace(/_/g, "-")
            .replace("-config", "");

        //Adding labelConfig
        cssString = cssString.concat(
            `.${classPrefix}-label {`,
            `color: ${config.labelConfig.fontColor};`,
            `font-style: ${config.labelConfig.fontStyle};`,
            `text-decoration: ${config.labelConfig.fontStyle};`,
            `font-weight: ${config.labelConfig.fontStyle};`,
            `font-size: ${config.labelConfig.fontSize}px;`,
            "}"
        );

        //Adding labelStyle
        cssString = cssString.concat(
            `.${classPrefix}-label-style { `,
            `color: ${config.labelConfig.fontColor}; `,
            `font-style: ${config.labelConfig.fontStyle}; `,
            `text-decoration: ${config.labelConfig.fontStyle}; `,
            `font-weight: ${config.labelConfig.fontStyle}; `,
            `font-size: ${config.labelConfig.fontSize}px; `,
            "}"
        );

        //Adding catalogConfig.header.regionConfig
        cssString = cssString.concat(
            `.${classPrefix}-catalog-header-region { `,
            `margin: ${config.catalogConfig.header.regionConfig.margin}; `,
            `padding: ${config.catalogConfig.header.regionConfig.padding}; `,
            `background: ${config.catalogConfig.header.regionConfig.background}; `,
            `border-radius: ${config.catalogConfig.header.regionConfig.corner}; `,
            "}"
        );

        //Adding catalogConfig.header.textConfig
        cssString = cssString.concat(
            `.${classPrefix}-catalog-header-text { `,
            `background: ${config.catalogConfig.header.textConfig.background};`,
            `width: ${
                config.layout != "l_noimage" &&
                config.layout != "l_banner" &&
                this.catalogLayoutConfig.listType != "card"
                    ? `calc(98% - ${config.catalogConfig.header.imageConfig.width})`
                    : "100%"
            };`,
            `color: ${config.catalogConfig.header.textConfig.textColor};`,
            "}"
        );

        //Adding headerTextStyleStr
        cssString = cssString.concat(
            `.${classPrefix}-header-text-style { `,
            `background: ${config.catalogConfig.header.textConfig.background}; `,
            `color: ${config.catalogConfig.header.textConfig.textColor}; `,
            "} ",
            `.${classPrefix}-header-text-style-image-no-banner-no-card { `,
            `width: calc(98% - ${config.catalogConfig.header.imageConfig.width}); `,
            "} ",
            `.${classPrefix}-header-text-style-no-image-or-banner-or-card { `,
            `width: 99%; `,
            "} "
        );

        //Adding bodyTextStyleStr
        cssString = cssString.concat(
            `.${classPrefix}-body-text-style { `,
            `background: ${config.catalogConfig.body.textConfig.background}; `,
            `color: ${config.catalogConfig.body.textConfig.textColor}; `,
            "} ",
            `.${classPrefix}-body-text-style-image-no-banner-no-card { `,
            `width: calc(98% - ${config.catalogConfig.body.imageConfig.width}); `,
            "} ",
            `.${classPrefix}-body-text-style-no-image-or-banner-or-card { `,
            `width: 99%; `,
            "} "
        );

        //Adding catalogConfig.header.imageConfig
        cssString = cssString.concat(
            `.${classPrefix}-catalog-header-image { `,
            `height: ${config.catalogConfig.header.imageConfig.height}; `,
            `width: ${config.catalogConfig.header.imageConfig.width}; `,
            `margin: ${config.catalogConfig.header.imageConfig.margin}; `,
            "} "
        );

        //Adding catalogConfig.body.regionConfig
        cssString = cssString.concat(
            `.${classPrefix}-catalog-body-region { `,
            `margin: ${config.catalogConfig.body.regionConfig.margin}; `,
            `padding: ${config.catalogConfig.body.regionConfig.padding}; `,
            `background: ${config.catalogConfig.body.regionConfig.background}; `,
            `border-radius: ${config.catalogConfig.body.regionConfig.corner}; `,
            "} "
        );

        //Adding catalogConfig.body.textConfig
        cssString = cssString.concat(
            `.${classPrefix}-catalog-body-text { `,
            `background: ${config.catalogConfig.body.textConfig.background};`,
            `width: ${
                config.layout != "l_noimage" &&
                config.layout != "l_banner" &&
                this.catalogLayoutConfig.listType != "card"
                    ? `calc(98% - ${config.catalogConfig.body.imageConfig.width})`
                    : "100%"
            };`,
            `color: ${config.catalogConfig.body.textConfig.textColor};`,
            "box-sizing: border-box;",
            "padding-right: 15px;",
            "}"
        );

        //Adding catalogConfig.body.imageConfig
        cssString = cssString.concat(
            `.${classPrefix}-catalog-body-image { `,
            `height: ${config.catalogConfig.body.imageConfig.height}; `,
            `width: ${config.catalogConfig.body.imageConfig.width}; `,
            `margin: ${config.catalogConfig.body.imageConfig.margin}; `,
            "} "
        );

        // headerImgStyle
        cssString = cssString.concat(this.createImageCss(config, classPrefix, "header"));
        // bodyImgStyle
        cssString = cssString.concat(this.createImageCss(config, classPrefix, "body"));

        return cssString;
    }

    private createImageCss(config, classPrefix, className) {
        let cssString = "";

        if (config.layout != "l_noimage" && config.layout != "l_banner") {
            cssString = cssString.concat(
                `.${classPrefix}-catalog-${className}-container {`,
                `height: ${config.catalogConfig[`${className}`].imageConfig.height};`,
                `width: ${config.catalogConfig[`${className}`].imageConfig.width};`,
                `background: ${config.catalogConfig[`${className}`].imageConfig.background};`,
                `margin-top: ${config.catalogConfig[`${className}`].imageConfig.margin};`,
                `margin-bottom: ${config.catalogConfig[`${className}`].imageConfig.margin};`,
                `border-radius: ${
                    config.layout === "l_circular" ? config.catalogConfig[`${className}`].imageConfig.height : "0px"
                };`,
                "}"
            );

            cssString = cssString.concat(
                `.${classPrefix}-catalog-${className}-img {`,
                `height: ${config.catalogConfig[`${className}`].imageConfig.height};`,
                `width: ${config.catalogConfig[`${className}`].imageConfig.width};`,
                `border-radius: ${
                    config.layout === "l_circular" ? config.catalogConfig[`${className}`].imageConfig.height : "0px"
                };`,
                `${
                    config.catalogConfig[`${className}`].imageConfig.background != null &&
                    config.catalogConfig[`${className}`].imageConfig.background.trim().length != 0
                        ? "-webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */ filter: grayscale(100%); opacity: 0.80;-moz-opacity: 80%;-webkit-opacity: 80%;"
                        : ""
                }`,
                "}"
            );
        } else if (config.layout === "l_banner") {
            cssString = cssString.concat(
                `.${classPrefix}-catalog-${className}-img {`,
                `height: calc(100% - 2 * ${config.catalogConfig[`${className}`].imageConfig.margin});`,
                `width: calc(100% - 2 * ${config.catalogConfig[`${className}`].imageConfig.margin});`,
                `margin: ${config.catalogConfig[`${className}`].imageConfig.margin};` + "}"
            );
        }

        return cssString;
    }

    private createCssSpeakerSession({ config }): string {
        config = JSON.parse(config);
        let cssString = "";

        // image style
        if (config.layout != "l_noimage" && config.layout != "l_banner") {
            cssString = cssString.concat(
                ".speaker-session-catalog-body-container {",
                `height: ${config.catalogConfig.body.imageConfig.height};`,
                `width: ${config.catalogConfig.body.imageConfig.width};`,
                `background: ${config.catalogConfig.body.imageConfig.background};`,
                `margin-top: ${config.catalogConfig.body.imageConfig.margin};`,
                `margin-bottom: ${config.catalogConfig.body.imageConfig.margin};`,
                `border-radius: ${
                    config.layout === "l_circular" ? config.catalogConfig.body.imageConfig.height : "0px"
                };`,
                "}"
            );
            cssString = cssString.concat(
                ".speaker-session-catalog-body-img {",
                `height: ${config.catalogConfig.body.imageConfig.height};`,
                `width: ${config.catalogConfig.body.imageConfig.width};`,
                `border-radius: ${
                    config.layout === "l_circular" ? config.catalogConfig.body.imageConfig.height : "0px"
                };`,
                `${
                    config.catalogConfig.body.imageConfig.background != null &&
                    config.catalogConfig.body.imageConfig.background.trim().length != 0
                        ? "-webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */ filter: grayscale(100%); opacity: 0.80;-moz-opacity: 80%;-webkit-opacity: 80%;"
                        : ""
                }`,
                "}"
            );
        } else if (config.layout === "l_banner") {
            cssString = cssString.concat(
                ".speaker-session-catalog-body-img {",
                `height: calc(100% - 2 * ${config.catalogConfig.body.imageConfig.margin});`,
                `width: calc(100% - 2 * ${config.catalogConfig.body.imageConfig.margin});`,
                `margin: ${config.catalogConfig.body.imageConfig.margin};`,
                "}"
            );
        }

        // catalog text
        cssString = cssString.concat(
            ".speaker-session-catalog-text {",
            `background: ${config.catalogConfig.body.textConfig.background};`,
            `width: ${
                config.layout != "l_noimage" &&
                config.layout != "l_banner" &&
                this.catalogLayoutConfig.listType != "card"
                    ? `calc(98% - ${config.catalogConfig.body.imageConfig.width})`
                    : "100%"
            };`,
            `color: ${config.catalogConfig.body.textConfig.textColor};`,
            "box-sizing: border-box;",
            "padding-right: 15px;",
            "}"
        );

        // catalog body
        cssString = cssString.concat(
            ".speaker-session-catalog-body {",
            `margin: ${config.catalogConfig.body.regionConfig.margin}; `,
            `padding: ${config.catalogConfig.body.regionConfig.padding}; `,
            `background: ${config.catalogConfig.body.regionConfig.background}; `,
            `border-radius: ${config.catalogConfig.body.regionConfig.corner}; `,
            "}"
        );

        return cssString;
    }

    public createCssGeneralData({ config }): string {
        config = JSON.parse(config);
        let cssString = "";

        // label general data
        cssString = cssString.concat(
            ".general-data-top-level-text {",
            `background-color: ${config.topLevel.textConfig.backgroundColor};`,
            `font-style: ${config.topLevel.textConfig.fontStyle};`,
            `text-decoration: ${config.topLevel.textConfig.fontStyle};`,
            `font-weight: ${config.topLevel.textConfig.fontStyle};`,
            `font-size: ${config.topLevel.textConfig.fontSize}px;`,
            `color: ${config.topLevel.textConfig.fontColor};`,
            "}"
        );

        return cssString;
    }
}
